import React from 'react'

export default function NotFound() {
  return (
    <div>
        <p>Uh oh! Page not found.</p>
    </div>
  )
}
